import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';

const LIVE_VIDEO_CALLER_EVENTS = Object.freeze({
  JOINED: 'live_video_caller_joined',
  LEFT: 'live_video_caller_left',
  REJOINED: 'live_video_caller_rejoined',
  MUTED: 'live_video_caller_muted',
  UNMUTED: 'live_video_caller_unmuted',
  TURNED_ON_CAMERA: 'live_video_caller_turned_on_camera',
  TURNED_OFF_CAMERA: 'live_video_caller_turned_off_camera',
  FLIPPED_CAMERA: 'live_video_caller_flipped_camera',
  ENTERED_DARK_MODE: 'live_video_caller_entered_dark_mode',
  LEFT_DARK_MODE: 'live_video_caller_left_dark_mode',
});

const trackLiveVideoEvent = ({
  event,
  type,
  data,
}: {
  event: (typeof LIVE_VIDEO_CALLER_EVENTS)[keyof typeof LIVE_VIDEO_CALLER_EVENTS];
  type: (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
  data: Record<string, unknown>;
}) => {
  const params = new URLSearchParams(window.location.search);
  gspx.trackEvent({
    name: event,
    type: type,
    feature: GPX_FEATURES.LIVE_VIDEO_CALLER,
    capability: GPX_CAPABILITIES.LIVE_VIDEO,
    route: GPX_ROUTES.LIVE_VIDEO,
    entities: {
      callToken: params.get('token'),
      ...data,
    },
  });
};

const simpleEvent = (
  event: (typeof LIVE_VIDEO_CALLER_EVENTS)[keyof typeof LIVE_VIDEO_CALLER_EVENTS],
) => {
  return () => {
    trackLiveVideoEvent({ event, type: GPX_EVENT_TYPES.CLICK, data: {} });
  };
};

export const trackLiveVideoCallerJoined = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.JOINED,
);
export const trackLiveVideoCallerLeft = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.LEFT,
);
export const trackLiveVideoCallerRejoined = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.REJOINED,
);
export const trackLiveVideoCallerMuted = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.MUTED,
);
export const trackLiveVideoCallerUnmuted = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.UNMUTED,
);
export const trackLiveVideoCallerTurnedOnCamera = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.TURNED_ON_CAMERA,
);
export const trackLiveVideoCallerTurnedOffCamera = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.TURNED_OFF_CAMERA,
);
export const trackLiveVideoCallerEnteredDarkMode = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.ENTERED_DARK_MODE,
);
export const trackLiveVideoCallerLeftDarkMode = simpleEvent(
  LIVE_VIDEO_CALLER_EVENTS.LEFT_DARK_MODE,
);

export const trackLiveVideoTCFlippedCallerCamera = (facing_mode: string) => {
  trackLiveVideoEvent({
    event: LIVE_VIDEO_CALLER_EVENTS.FLIPPED_CAMERA,
    type: GPX_EVENT_TYPES.CLICK,
    data: {
      facing_mode,
    },
  });
};
